export const URL_API = "https://api.synckonnect.com"
// export const URL_API = "https://server.x-scope.net" // Antiguo
//export const URL_API = "http://localhost:3001"
//export const KEY_CAPCHA = "6LdTptohAAAAAMTBnc0YsPJnRPc0Z2BnINoHnXnU"
//export const KEY_CAPCHA = "6LcvcfchAAAAAEebXfZ-23e8DcoSFj-9YKR5HNCP"
export const KEY_CAPCHA = "6Ldl2BAnAAAAAHqNFiXmqIGCR_ktyk5Uk98Oys65"